import React, { useState, FormEvent, useEffect } from 'react';
import { FormGroup, InputGroup, Button, AnchorButton, Checkbox, HTMLTable } from "@blueprintjs/core";
import { AxiosInstance } from 'axios';
import { useTranslation } from 'react-i18next';

import { Environment } from './Types'
import * as utils from "./utils";

interface FRRProps {
    svc: AxiosInstance,
    currentEnv?: Environment,
}

function FRR({ svc, currentEnv = {} as Environment }: FRRProps) {
    const { t, i18n } = useTranslation();

    let date = new Date(), y = date.getFullYear(), m = date.getMonth()
    const [from, setFrom] = useState(utils.formatDate(new Date(currentEnv.startOfYear)))
    const [to, setTo] = useState(utils.formatDate(date))

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('frr_download')}</div>
            <div className="Spacing-V-16"></div>
            <form className="No-Print">
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('from')} labelFor="from">
                        <InputGroup id="from" value={from} type="date" onChange={utils.handleStringChange(s => setFrom(s))} />
                    </FormGroup>
                    <FormGroup className="Col-2-1" label={t('to')} labelFor="to">
                        <InputGroup id="to" value={to} type="date" onChange={utils.handleStringChange(s => setTo(s))} />
                    </FormGroup>
                    <AnchorButton className="Col-3-1 Button-LabeledFormGroup" icon="download" target="_blank" href={`${svc.defaults.baseURL}/downloadfrrsdt?from=${from}&to=${to}`}>{t('frr_data_file')}</AnchorButton>
                </div>
            </form>
        </>
    );
}

export default FRR